import { cdnUrl } from "@/consts";

function extractQueueFileId(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  if (trimmed.includes("://")) {
    try {
      const u = new URL(trimmed.startsWith("//") ? `https:${trimmed}` : trimmed);
      const segments = u.pathname.split("/").filter(Boolean);
      if (segments.length === 0) return null;
      const id = segments[0]!.split("?")[0];
      return id || null;
    } catch {
      return null;
    }
  }

  const noQuery = trimmed.split("?")[0] ?? "";
  const normalized = noQuery.replace(/^\/+/, "");
  if (!normalized) return null;
  const id = normalized.split("/")[0]!.split("?")[0];
  return id || null;
}

/**
 * Image src for queue uploads: `${cdnUrl}/${fileId}`. Strips CloudFront / legacy hosts to the path id,
 * matching portal player-form behavior.
 */
export function resolveQueueImageSrc(value: string | null | undefined): string | null {
  if (!value?.trim()) return null;
  const trimmed = value.trim();
  if (trimmed.startsWith("data:") || trimmed.startsWith("blob:")) return trimmed;

  const base = cdnUrl.replace(/\/$/, "");
  const fileId = extractQueueFileId(trimmed);

  if (base && fileId) {
    return `${base}/${encodeURIComponent(fileId)}`;
  }

  if (base && !trimmed.includes("://")) {
    return `${base}/${encodeURIComponent(trimmed)}`;
  }

  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }

  return null;
}
